module.exports = __webpack_public_path__ + "static/site-e-commerce-3455753a5451ab9e97f5a38ee822848c.jpg";